import Plan from "types/Plan";
import { DataRouteDefinition } from "routes/data-routes/types";


export const PlansDataRoutePath = "/data-routes/billing-data/plans";

export type PlansDataRouteType = Required<DataRouteDefinition<Plan[][], "allPlans", typeof PlansDataRoutePath>>;
